import { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { LanguageWrapper } from '@/components/LanguageWrapper'
import { Layout } from '@/components/layout/Layout'
import { LoadingSpinner } from '@/components/ui/LoadingSpinner'
import { ChatBot } from '@/components/ChatBot'
import { CookieConsent } from '@/components/CookieConsent'
import { ScrollToTop } from '@/components/ScrollToTop'
import { defaultLanguage } from '@/i18n'

// Lazy-loaded pages for code splitting
const HomePage = lazy(() => import('@/pages/HomePage').then(m => ({ default: m.HomePage })))
const AboutPage = lazy(() => import('@/pages/AboutPage').then(m => ({ default: m.AboutPage })))
const TechnicalAssistancePage = lazy(() => import('@/pages/TechnicalAssistancePage').then(m => ({ default: m.TechnicalAssistancePage })))
const EquipmentSalesPage = lazy(() => import('@/pages/EquipmentSalesPage').then(m => ({ default: m.EquipmentSalesPage })))
const PumpRepairPage = lazy(() => import('@/pages/PumpRepairPage').then(m => ({ default: m.PumpRepairPage })))
const CalmixPage = lazy(() => import('@/pages/CalmixPage').then(m => ({ default: m.CalmixPage })))
const ProductsPage = lazy(() => import('@/pages/ProductsPage').then(m => ({ default: m.ProductsPage })))
const PartnersPage = lazy(() => import('@/pages/PartnersPage').then(m => ({ default: m.PartnersPage })))
const ContactPage = lazy(() => import('@/pages/ContactPage').then(m => ({ default: m.ContactPage })))
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage').then(m => ({ default: m.PrivacyPage })))
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage').then(m => ({ default: m.NotFoundPage })))

function AppRoutes() {
  return (
    <Layout>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="chi-siamo" element={<AboutPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="a-propos" element={<AboutPage />} />
          <Route path="ueber-uns" element={<AboutPage />} />
          <Route path="quienes-somos" element={<AboutPage />} />
          <Route path="sobre-nos" element={<AboutPage />} />
          <Route path="assistenza-tecnica" element={<TechnicalAssistancePage />} />
          <Route path="technical-assistance" element={<TechnicalAssistancePage />} />
          <Route path="assistance-technique" element={<TechnicalAssistancePage />} />
          <Route path="technische-assistenz" element={<TechnicalAssistancePage />} />
          <Route path="asistencia-tecnica" element={<TechnicalAssistancePage />} />
          <Route path="assistencia-tecnica" element={<TechnicalAssistancePage />} />
          <Route path="vendita-strumentazione" element={<EquipmentSalesPage />} />
          <Route path="equipment-sales" element={<EquipmentSalesPage />} />
          <Route path="vente-instruments" element={<EquipmentSalesPage />} />
          <Route path="geraeteverkauf" element={<EquipmentSalesPage />} />
          <Route path="venta-instrumentacion" element={<EquipmentSalesPage />} />
          <Route path="venda-instrumentacao" element={<EquipmentSalesPage />} />
          <Route path="riparazione-pompe" element={<PumpRepairPage />} />
          <Route path="pump-repair" element={<PumpRepairPage />} />
          <Route path="reparation-pompes" element={<PumpRepairPage />} />
          <Route path="pumpenreparatur" element={<PumpRepairPage />} />
          <Route path="reparacion-bombas" element={<PumpRepairPage />} />
          <Route path="reparacao-bombas" element={<PumpRepairPage />} />
          <Route path="calmix" element={<CalmixPage />} />
          <Route path="prodotti" element={<ProductsPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="produits" element={<ProductsPage />} />
          <Route path="produkte" element={<ProductsPage />} />
          <Route path="productos" element={<ProductsPage />} />
          <Route path="produtos" element={<ProductsPage />} />
          <Route path="partners" element={<PartnersPage />} />
          <Route path="partenaires" element={<PartnersPage />} />
          <Route path="partner" element={<PartnersPage />} />
          <Route path="socios" element={<PartnersPage />} />
          <Route path="parceiros" element={<PartnersPage />} />
          <Route path="contatti" element={<ContactPage />} />
          <Route path="contacts" element={<ContactPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="kontakt" element={<ContactPage />} />
          <Route path="contacto" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="confidentialite" element={<PrivacyPage />} />
          <Route path="datenschutz" element={<PrivacyPage />} />
          <Route path="privacidad" element={<PrivacyPage />} />
          <Route path="privacidade" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />
        <Route path="/:lang/*" element={<LanguageWrapper />}>
          <Route path="*" element={<AppRoutes />} />
        </Route>
      </Routes>
      <ChatBot />
      <CookieConsent />
    </>
  )
}
